// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-a0330156] .viewerContainer{overflow:visible!important}#preViewPdf[data-v-a0330156]{background:#ebeef5!important}.inputss[data-v-a0330156]{width:25rem;height:3.75rem;margin-top:1.5625rem;margin-left:1.25rem;border-radius:.3125rem;border:.0625rem solid#DCDFE6}.btn_1[data-v-a0330156]{margin-left:.9375rem}", ""]);
// Exports
module.exports = exports;
